import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const faqData = [
  {
    question: '¿Cómo llego al hotel desde el aeropuerto de Tarapoto?',
    answer: 'Estamos ubicados a solo 10 minutos del Aeropuerto Cadete FAP Guillermo del Castillo Paredes. Ofrecemos un servicio de traslado coordinado para su comodidad. Por favor, contáctenos con los detalles de su vuelo para organizarlo.',
  },
  {
    question: '¿El desayuno está incluido en todas las tarifas?',
    answer: 'Sí, todas nuestras reservas incluyen un delicioso y variado desayuno para empezar el día con energía. Es servido diariamente en nuestro restaurante de 7:00 AM a 10:00 AM.',
  },
  {
    question: '¿Cuentan con conexión a internet (Wi-Fi)?',
    answer: 'Sí, ofrecemos conexión Wi-Fi de cortesía en todas las habitaciones y áreas comunes del hotel, para que pueda mantenerse conectado durante su estadía.',
  },
  {
    question: '¿El hotel admite mascotas?',
    answer: 'Aunque apreciamos mucho a los animales, por el momento nuestras instalaciones no están acondicionadas para recibir mascotas, con el fin de garantizar la comodidad de todos nuestros huéspedes.',
  },
  {
    question: '¿Qué actividades o tours se pueden realizar?',
    answer: '¡Muchas! Sumaq Mayu es el punto de partida perfecto para la aventura. Podemos ayudarle a organizar una variedad de actividades, como excursiones a la selva, paseos en bote por el río, visitas a las famosas cataratas de la región y tours culturales. No dude en consultar en nuestra recepción para más información y recomendaciones personalizadas.',
  },
  {
    question: '¿Qué tan lejos está el hotel del centro de la ciudad?',
    answer: 'Nos encontramos en un entorno natural y tranquilo, ideal para el descanso, a aproximadamente 15-20 minutos en vehículo del centro de Tarapoto. Esta ubicación nos permite ofrecer una experiencia de paz sin estar desconectados de la ciudad.',
  },
];

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200 py-6">
      <button
        className="flex justify-between items-center w-full text-left focus:outline-none"
        onClick={onClick}
      >
        <h3 className="text-xl font-playfair font-medium text-gray-800">{question}</h3>
        <div className="text-green-700">
          {isOpen ? <FaMinus size={20} /> : <FaPlus size={20} />}
        </div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0, marginTop: 0 }}
            animate={{ opacity: 1, height: 'auto', marginTop: '16px' }}
            exit={{ opacity: 0, height: 0, marginTop: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <p className="text-gray-600 leading-relaxed text-base lg:text-lg">{answer}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleItemClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-gray-50">
      <Navbar />
      
      <header 
        className="relative bg-cover bg-center pt-40 pb-24" 
        style={{ backgroundImage: `url(/images/cta-bg.jpg)` }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative container mx-auto px-4 text-center text-white">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl sm:text-5xl md:text-6xl font-playfair font-bold"
          >
            Preguntas Frecuentes
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-4 text-lg max-w-3xl mx-auto"
          >
            Aquí resolvemos tus dudas más comunes. Si no encuentras tu respuesta, no dudes en contactarnos directamente.
          </motion.p>
        </div>
      </header>

      <main className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8 max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
            className="bg-white p-6 sm:p-10 rounded-2xl shadow-xl"
          >
            {faqData.map((faq, index) => (
              <FAQItem 
                key={index} 
                question={faq.question} 
                answer={faq.answer} 
                isOpen={openIndex === index}
                onClick={() => handleItemClick(index)}
              />
            ))}
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FAQ;

